import React from 'react';
import { Headset, BadgeCheck } from 'lucide-react';
import 'aos/dist/aos.css';

const AboutUs = () => {
  return (
    <section
      className="py-16 px-4 sm:px-8 md:px-10 lg:px-20 xl:px-28 2xl:px-40"
      style={{ backgroundColor: '#F1F0EA', color: '#534B52' }}
    >
      <div className="max-w-screen-2xl mx-auto">
        {/* Section Title */}
        <div data-aos="fade-up" className="mb-12 text-center">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl 2xl:text-6xl font-bold mb-4"
            style={{ color: '#474448' }}
          >
            Driven by Precision, Defined by Vision
          </h2>
          <p
            className="text-lg sm:text-xl lg:text-2xl"
            style={{ color: '#534B52' }}
          >
            Your Trusted and Visionary Partner in CED Coating Excellence
          </p>
        </div>

        {/* Company Overview */}
        <div
          data-aos="fade-up"
          className="mb-16 text-base sm:text-lg lg:text-xl leading-relaxed"
        >
          <p>
            Founded in 2024, we <strong>CED Coatings</strong> are a well-recognized
            organization headquartered in New Delhi. Our firm provides services in
            manufacturing chassis, child parts, and delivering premium CED and powder
            coating solutions for all metal surfaces. We dare to accept challenges and
            consistently deliver optimum quality with timely execution.
          </p>
        </div>

        {/* Highlights with Icons */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 xl:gap-20">
          {/* 24/7 Premium Support */}
          <div data-aos="fade-right" className="flex items-start gap-5">
            <div className="bg-[#2D232E] text-white p-3 lg:p-4 2xl:p-5 rounded-full shadow-lg">
              <Headset size={32} className="2xl:w-10 2xl:h-10" />
            </div>
            <div>
              <h3
                className="text-xl sm:text-2xl lg:text-3xl font-semibold mb-1"
                style={{ color: '#474448' }}
              >
                24/7 Premium Support
              </h3>
              <p className="text-base lg:text-lg" style={{ color: '#534B52' }}>
                Providing round-the-clock premium support to ensure your success anytime,
                anywhere.
              </p>
            </div>
          </div>

          {/* Professional Expert */}
          <div data-aos="fade-left" className="flex items-start gap-5">
            <div className="bg-[#2D232E] text-white p-3 lg:p-4 2xl:p-5 rounded-full shadow-lg">
              <BadgeCheck size={32} className="2xl:w-10 2xl:h-10" />
            </div>
            <div>
              <h3
                className="text-xl sm:text-2xl lg:text-3xl font-semibold mb-1"
                style={{ color: '#474448' }}
              >
                Professional Expert
              </h3>
              <p className="text-base lg:text-lg" style={{ color: '#534B52' }}>
                Bringing unparalleled expertise and professionalism to every project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
